<template>
	<main class="page-container" id="join-intro">
		<section class="mbrp-section">
			<div class="container">
				<header class="mbrp-header">
					<h2 class="title">동행축제 회원 가입하기</h2>
				</header>
				<div class="mbrp-body">
					<!-- steps -->
					<div class="steps-wrapper">
						<ol class="steps">
							<li class="steps-segment is-complete">
								<div class="steps-inner">
									<span class="steps-marker">
										<span class="icon">1</span>
									</span>
									<div class="steps-content">
										<p class="heading">약관동의</p>
									</div>
								</div>
							</li>
							<li class="steps-segment is-complete">
								<div class="steps-inner">
									<span class="steps-marker">
										<span class="icon">2</span>
									</span>
									<div class="steps-content">
										<p class="heading">회원정보 입력</p>
									</div>
								</div>
							</li>
							<li class="steps-segment is-active">
								<div class="steps-inner">
									<span class="steps-marker">
										<span class="icon">3</span>
									</span>
									<div class="steps-content">
										<p class="heading">회원가입 완료</p>
									</div>
								</div>
							</li>
						</ol>
					</div>
					<!-- //steps -->

					<section class="mbrp-complete">
						<h3 class="mbrp-complete-header">동행축제 회원가입 완료</h3>

						<div class="mbrp-complete-content">
							<div class="success-checkmark">
								<div class="check-icon">
									<span class="icon-line line-tip"></span>
									<span class="icon-line line-long"></span>
									<div class="icon-circle"></div>
									<div class="icon-fix"></div>
								</div>
							</div>
							<strong class="mbrp-complete-content__title"> 환영합니다. {{userNm}} 님. </strong>
							<p class="mbrp-complete-content__desc">
								회원가입이 완료되었습니다. <br />
								<strong class="color-orange">동행축제</strong> 서비스를 이용하시려면 지금 바로 로그인 하세요.
							</p>
						</div>
					</section>
					<div class="buttons text-center">
						<!-- <router-link to="/login" class="button-default is-large is-primary is-rounded">로그인</router-link> -->
						<a href="https://www.k-shoppingfesta.org" class="button-default is-large is-primary is-rounded">로그인</a>
					</div>
				</div>
			</div>
		</section>
	</main>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
	name: 'JoinDhFestaComplete',
	components: {},
	computed: {
		...mapGetters('auth', ['session', 'isAuth', 'checkMeInfo']),
		...mapGetters('common', ['isMobile']),
    ...mapGetters('join', ['userNm']),
	},
	watch: {},
	data: () => ({
  }),
	mounted() {},
  methods: {
		dhGoLogin(){
			this.$router.push('https://www.k-shoppingfesta.org');
		},
	},
	destroyed() {},
};
</script>
